import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { withRouter } from "react-router-dom";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Execution from "../../images/settings.png";
import Waiting from "../../images/wait.png";
import Planning from "../../images/writing.png";
import Confirm from "../../images/confirm.png";
import Verified from "../../images/verified.png";
import Cancelled from "../../images/prohibition.png";


const styles = theme => ({

});

class ListPaid extends Component {
  gotoWorkshop = item => {
    this.props.history.push({
      pathname: "/workshop",
      // id, workshopSFID, source, stagename
      search: `?id=${item.id}&workshopSFID=${item.sfid
        }&source=lists&stagename=${item.stagename}&heroku_id__c=${item.heroku_id__c}`
    });
  };

  render() {
    const { listitems } = this.props;

    return (
      <Fragment>
        <List>
          {listitems.map(item => {
            return (
              <Paper key={item.id}>
                {/* <ListItem alignItems="flex-start">
                  <ListItemText
                    disableTypography
                    onClick={() => this.gotoWorkshop(item)}
                    primary={
                      <Typography variant="body2" style={{ fontSize: 15 }}>
                        {item.name}
                      </Typography>
                    }
                    secondary={
                      <Typography component="span">
                        {item.end_date_time__c}
                      </Typography>
                    }
                  />
                  <ListItemSecondaryAction>
                    <Typography
                      component="span"
                      style={{ paddingRight: 10 }}
                    >
                      {item.stagename}
                      {item.stagename === "Planning" &&
                        <img src={Planning} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {item.stagename === "Awaiting Workshop Confirmation" &&
                        <img src={Waiting} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {item.stagename === "Awaiting AMMD Approval" &&
                        <img src={Waiting} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {item.stagename === "AMMD Confirmation" &&
                        <img src={Confirm} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {item.stagename === "Execution" &&
                        <img src={Execution} style={{ width: '35px', paddingLeft: '10px' }} />
                      }
                      {item.stagename === "CMDI Verification" &&
                        <img src={Verified} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {item.stagename === "Paid" &&
                        <img src={Confirm} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                      {item.stagename === "Cancelled" &&
                        <img src={Cancelled} style={{ width: '30px', paddingLeft: '10px' }} />
                      }
                    </Typography>
                    <Typography component="span">
                        {item.payment_date__c}
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem> */}
                <Grid
                  container
                  spacing={8}
                  alignItems="center"
                  justify="space-between"
                >
                  <Grid
                    item
                    xs={6}
                    style={{ padding: 15 }}
                    onClick={() => this.gotoWorkshop(item)}
                  >
                    <Typography align="left" variant="body2" component="" style={{ fontSize: 12 }}>
                      {item.name}
                    </Typography>
                    <Typography align="left" variant="caption" component="p">
                      {item.end_date_time__c}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right" style={{ paddingRight: 10 }} zeroMinWidth >
                      <div className="d-flex justify-content-end">
                        <div className="align-self-center">{item.stagename}</div>
                        <div className="align-self-center">
                          {item.stagename === "Planning" &&
                            <img src={Planning} style={{ width: '30px', paddingLeft: '10px' }} />
                          }
                          {item.stagename === "Awaiting Workshop Confirmation" &&
                            <img src={Waiting} style={{ width: '30px', paddingLeft: '10px' }} />
                          }
                          {item.stagename === "Awaiting AMMD Approval" &&
                            <img src={Waiting} style={{ width: '30px', paddingLeft: '10px' }} />
                          }
                          {item.stagename === "AMMD Confirmation" &&
                            <img src={Confirm} style={{ width: '30px', paddingLeft: '10px' }} />
                          }
                          {item.stagename === "Execution" &&
                            <img src={Execution} style={{ width: '35px', paddingLeft: '10px' }} />
                          }
                          {item.stagename === "CMDI Verification" &&
                            <img src={Verified} style={{ width: '30px', paddingLeft: '10px' }} />
                          }
                          {item.stagename === "Paid" &&
                            <img src={Confirm} style={{ width: '30px', paddingLeft: '10px' }} />
                          }
                          {item.stagename === "Cancelled" &&
                            <img src={Cancelled} style={{ width: '30px', paddingLeft: '10px' }} />
                          }
                          {item.stagename === "Account Approved" &&
                            <img src={Confirm} style={{ width: '30px', paddingLeft: '10px' }} />
                          }
                        </div>
                      </div>

                    </Typography>
                  </Grid>
                </Grid>
                <Divider />
              </Paper>
            );
          })}
        </List>
      </Fragment>
    );
  }
}

ListPaid.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(ListPaid));